import styled from 'styled-components/macro';

export const SelectMoneyWrapper = styled.div``;
